import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Button, Modal, Dropdown } from "react-bootstrap";
import axios from "axios";
import GoBack from "../General/GoBack";

import API_URL from "../../localhost/config"; // Importa la variable global

//Toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../utils/Spinner";

const notifySuccess = (mensaje) => {
  toast.success(mensaje, {
    position: "bottom-right",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

const notifyWanr = (mensaje) => {
  toast.warn(mensaje, {
    position: "bottom-right",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

const DropdownModal = ({ info, cambiarEquipo, equipoSeleccionado }) => {
  return (
    <div className="dropdown">
      <button
        className="btn btn-outline-secondary dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {equipoSeleccionado ? equipoSeleccionado?.Nombre : "Seleccionar equipo"}
      </button>
      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        {info?.map((equipo) => (
          <li key={equipo.id}>
            <button
              className="dropdown-item"
              onClick={() => cambiarEquipo(equipo)}
            >
              {equipo?.Nombre}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

const ModalCompartir = ({ mostrarModal, cerrarModal, equipo, equipos }) => {
  const [equiposComparten, setEquiposComparten] = useState([]);
  const [datoEquiposCompartidos, setEquiposCompartidos] = useState([]);
  const [equiposRestantes, setEquiposRestantes] = useState([equipos]);
  const [equipoSeleccionado, setEquipoSeleccionado] = useState(null);

  //Loading
  const [isLoading, setIsLoading] = useState(true); // Estado para controlar si los datos están cargados

  const handleEquipoSeleccionado = (equipo) => {
    setEquipoSeleccionado(equipo);
  };

  useEffect(() => {
    // Función para obtener las prioridades
    const obtenerEquiposComparten = async () => {
      setIsLoading(true);
      try {
        if (equipo) {
          const response = await axios.get(
            `${API_URL}/getIdEquiposComparte?idEquipo=${equipo.id}`
          );
          setEquiposComparten(response.data);
        }
      } catch (error) {
        // console.error("Error al obtener prioridades:", error.message);
        setEquiposComparten([]);
        notifyWanr("Error al buscar equipos comparten");
      } finally {
        setIsLoading(false);
      }
    };

    obtenerEquiposComparten();
  }, [equipo]);

  useEffect(() => {
    const arrayEquiposComparten = async () => {
      const equiposCompartidos = await equiposComparten.map(
        (idEquipoComparte) => {
          const infoEquipo = equipos.find(
            (equipo) =>
              equipo.id === Number(idEquipoComparte?.idEquipoCompartidos)
          );
          return infoEquipo;
        }
      );

      setEquiposCompartidos(equiposCompartidos);

      // Filtrar array1 basado en los ids de array2
      const resultadoFiltrado = await equipos?.filter(
        (objeto) => !equiposCompartidos.some((item) => item?.id === objeto.id)
      );
      setEquiposRestantes(resultadoFiltrado);
    };

    arrayEquiposComparten();
  }, [equiposComparten, equipo]);

  const agregarEquipoComparte = async (equipoCompartido) => {
    try {
      await axios.post(
        `${API_URL}/addEquiposComparte?idEquipo=${equipo.id}&idEquipoComparte=${equipoCompartido.id}`
      );
      setEquiposCompartidos([...datoEquiposCompartidos, equipoCompartido]);

      const nuevosEquiposCompartidos = equiposRestantes.filter(
        (equipo) => equipo.id !== equipoCompartido.id
      );
      setEquiposRestantes(nuevosEquiposCompartidos);

      setEquipoSeleccionado(null);
      notifySuccess("Equipo agregado");

      //setSuccessMessage("Equipos compartidos agregado exitosamente.");
    } catch (error) {
      //setError("Error al agregar el equipo:", error.message);
      notifyWanr("Ocurrio un error al agregar Equipo");
    }
  };

  const eliminarEquipoComparte = async (equipoCompartido) => {
    try {
      await axios.delete(
        `${API_URL}/deleteEquipoComparte?idEquipo=${equipo.id}&idEquipoComparte=${equipoCompartido.id}`
      );
      const nuevosEquipos = datoEquiposCompartidos.filter(
        (e) => e.id !== equipoCompartido.id
      );
      setEquiposCompartidos(nuevosEquipos);

      setEquiposRestantes([...equiposRestantes, equipoCompartido]);

      setEquipoSeleccionado(null);
      // console.log("Voy a eliminar ", equipo.id, equipoCompartido.id);
      notifySuccess("Equipo eliminado");
      //setSuccessMessage("Equipos compartidos agregado exitosamente.");
    } catch (error) {
      //setError("Error al agregar el equipo:", error.message);
      notifyWanr("Ocurrio un error al eliminar equipo");
    }
  };

  //Token
  const [token, setToken] = useState(localStorage.getItem("token"));

  // Limpiar la selección cuando se cierra el modal
  const handleCloseModal = () => {
    setEquipoSeleccionado(null);
    cerrarModal();
  };

  return (
    <div>
      <Modal show={mostrarModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{equipo?.Nombre} comparte jugadores con:</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? (
            <Spinner />
          ) : equiposComparten && equiposComparten.length > 0 ? (
            <div class="col">
              {datoEquiposCompartidos.map((equipo) => {
                return (
                  <div
                    key={equipo?.id}
                    className="g-0 align-items-center py-3"
                    style={{ borderBottom: "1px solid #ccc" }}
                  >
                    <span>{equipo?.Nombre}</span>
                    <i
                      className="fas fa-trash me-2 text-danger "
                      onClick={(e) => {
                        e.stopPropagation(); // Detener la propagación del evento
                        eliminarEquipoComparte(equipo);
                      }}
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Eliminar equipo compartido"
                      style={{ cursor: "pointer", fontSize: "18px" }}
                    ></i>
                  </div>
                );
              })}
            </div>
          ) : (
            <div>
              <p>No hay equipos compartidos.</p>
            </div>
          )}
          {isLoading ? null : (
            <div>
              {" "}
              <Modal.Footer>
                <DropdownModal
                  info={equiposRestantes}
                  cambiarEquipo={handleEquipoSeleccionado}
                  equipoSeleccionado={equipoSeleccionado}
                />
                <Button
                  onClick={() => agregarEquipoComparte(equipoSeleccionado)}
                >
                  Enviar
                </Button>
                <Button variant="secondary" onClick={handleCloseModal}>
                  Cerrar
                </Button>
              </Modal.Footer>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ModalCompartir;
